<template>

    <v-page>

        <transition name="modal">
            <v-modal-segment-new v-if="segment && showModal === 'new'" :segment="segment" />
            <v-modal-segment-sync v-if="segment && showModal === 'sync'" :segment="segment" @synced="getSegment" />
        </transition>

        <v-page-header icon="fas fa-chart-pie">
            <v-breadcrumb>
                <v-breadcrumb-item><router-link :to="{ name: 'segments' }">Segments</router-link></v-breadcrumb-item>
                <v-breadcrumb-item v-if="segment" :title="segment.name" @changed="changeSegmentName" @saved="updateSegmentName" editable />
            </v-breadcrumb>
        </v-page-header>

        <v-page-filters>
            <v-button-toolbar v-if="segment">
                <v-identifier :uuid="segment.id" />
                <v-button size="xs" btn-style="white" v-if="segment && segment.synced_at" @click.native="$store.commit('showModal', 'sync')">Synced: {{ segment.synced_at | dateTime }}</v-button>
            </v-button-toolbar>
            <v-button-toolbar>
                <v-button size="sm" btn-style="secondary" @click.native="$store.commit('showModal', 'new')">Save As</v-button>
                <v-button size="sm" :loading="loading" @click.native="updateSegment">Save Segment</v-button>
            </v-button-toolbar>
        </v-page-filters>

        <v-page-body>
            <v-segmenter :model="segment" @search="searchCustomers(1)" />
            <v-loader v-if="customers === null" size="lg" centered />
            <v-page-section v-else padded>
                <template #title>
                    <span>{{ customersPagination | paginationTitle('Customers (', ')') }}</span>
                </template>
                <template #body>
                    <v-notice v-if="!customers.length" title="No Customers Found" message="No customers currently match this segment." />
                    <v-table-customers v-else :customers="customers" />
                </template>
                <template #footer>
                    <v-pagination :count="customersPagination.last_page" @search="paginateCustomers($event)" />
                </template>
            </v-page-section>
        </v-page-body>

    </v-page>

</template>

<style scoped lang="scss">

    .save-as {
        @include shad(2);
        background: #fff;
        border: 1px solid $color-rule;
        border-radius: 5px;
        display: flex;
        margin-top: 45px;
        padding: 10px;
        position: absolute;
        right: 0;
        top: 0;
        z-index: 1;
    }

</style>

<script>

import axios from 'axios';
import ModalSegmentNew from '@modals/segment/ModalSegmentNew';
import ModalSegmentSync from '@modals/segment/ModalSegmentSync';
import ProjectApi from '@api/ProjectApi';
import SegmentApi from '@api/SegmentApi';

export default {

    components: {
        'v-modal-segment-new': ModalSegmentNew,
        'v-modal-segment-sync': ModalSegmentSync,
    },

    data() {
        return {
            loading: false,
            segment: null,
            // Results
            customers: null,
            customersPagination: {},
            customersParams: {
                sort_key: this.$route.query.sort_key,
                sort_dir: this.$route.query.sort_dir,
            },
        }
    },

    mounted() {
        this.getSegment();
    },

    watch: {

        $route(val) {
            this.customersParams.sort_key = val.query.sort_key;
            this.customersParams.sort_dir = val.query.sort_dir;
            this.searchCustomers(1);
        },

    },

    methods: {

        getSegment() {
            this.$store.commit('loading', true);
            let requests = [
                ProjectApi.getProject(this.project.id),
                SegmentApi.getSegment(this.$route.params.id),
            ];
            axios.all(requests)
                .then(axios.spread((resProject, resSegment) => {
                    this.$store.commit('loading', false);
                    this.segment = resSegment.data.data;
                    this.loadCustomers();
                    this.$events.$emit('pageLoaded');
                }), () => {
                    this.$store.commit('loading', false);
                    this.$events.$emit('pageError');
                });
        },

        paginateCustomers(page) {
            window.scrollTo(0, 0);
            this.searchCustomers(page);
        },

        loadCustomers() {
            this.$store.commit('loading', true);
            this.customersParams.page = 1;
            this.customersParams.op = this.segment.op;
            this.customersParams.rules = this.segment.rules;
            ProjectApi.searchCustomers(this.project.id, this.customersParams)
                .then((response) => {
                    this.$store.commit('loading', false);
                    this.customers = response.data.data;
                    this.customersPagination = response.data.pagination;
                }, (error) => {
                    this.$store.commit('loading', false);
                    this.$store.commit('setAlertWithError', error);
                });
        },

        searchCustomers(page = 1) {
            this.$store.commit('loading', true);
            this.customersParams.page = page;
            this.customersParams.op = this.$store.getters['segmenter/op'];
            this.customersParams.rules = this.$store.getters['segmenter/rules'];
            ProjectApi.searchCustomers(this.project.id, this.customersParams)
                .then((response) => {
                    this.$store.commit('loading', false);
                    this.customers = response.data.data;
                    this.customersPagination = response.data.pagination;
                }, (error) => {
                    this.$store.commit('loading', false);
                    this.$store.commit('setAlertWithError', error);
                });
        },

        updateSegment() {
            this.loading = true;
            let params = {};
            params.name = this.segment.name;
            params.op = this.$store.getters['segmenter/op'];
            params.rules = this.$store.getters['segmenter/rules'];
            SegmentApi.updateSegment(this.segment.id, params)
                .then((response) => {
                    this.loading = false;
                    this.$store.commit('setAlertSuccess', this.$t('message.saved'));
                }, (error) => {
                    this.loading = false;
                    this.$store.commit('setAlertWithError', error);
                });
        },

        changeSegmentName(name) {
            this.segment.name = name;
        },

        updateSegmentName(name) {
            this.$store.commit('loading', true);
            SegmentApi.updateSegmentName(this.segment.id, name)
                .then((response) => {
                    this.$store.commit('loading', false);
                    this.$store.commit('setAlertSuccess', this.$t('message.saved'));
                    this.segment.name = name;
                }, (error) => {
                    this.$store.commit('loading', false);
                    this.$store.commit('setAlertWithError', error);
                });
        },

    }

}

</script>